import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import areaSelect from '@/components/cascader.vue';
import controlItem from './controlItem.vue';
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { statistics, control, controlGroup, fileFormat, controlGroupInfo } from './utilscopy';
import { uploadFile } from '../../customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import { getBase64, isImage, isVideo, isPDF } from '@/views/claim/demageManage/utils';
export default {
  components: {
    topTitle,
    areaSelect,
    previewModal,
    controlItem
  },
  data() {
    return {
      //图片需要参数
      action: uploadFile,
      uploadAccept: '',
      checkAll: false,
      indeterminate: false,
      fileDialog: false,
      previewVisible: false,
      previewSrc: '',
      previewPDF: '',
      isPDFShow: false,
      isShow: '',
      currentPreviewIndex: 0,
      statistics,
      control,
      controlGroup,
      dialogVisible: false,
      isEdit: false,
      dataForm: {
        partsType: '',
        formName: '',
        controlName: '',
        controlExplain: '',
        promptText: '',
        other: '',
        type: '',
        optionList: [],
        fileFormat: [],
        template: []
      },
      dataGroupForm: {},
      dataRules: {},
      dataGroupRules: {},
      name: '',
      controlType: '',
      checked: false,
      controlList: [],
      plainOptions: []
    };
  },
  computed: {
    controlInfo() {
      return {
        1: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }]
        },
        2: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          option: [{
            required: true,
            message: this.$t('请填写控件选项，不同选项用“，”隔开'),
            trigger: 'blur'
          }]
        },
        3: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          type: [{
            required: true,
            message: this.$t('请选择') + this.$t('类别'),
            trigger: 'change'
          }]
        },
        4: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          dateType: [{
            required: true,
            message: this.$t('请选择') + this.$t('日期类型'),
            trigger: 'change'
          }]
        },
        5: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          fileFormat: [{
            type: 'array',
            required: true,
            message: this.$t('请选择') + this.$t('文件格式'),
            trigger: 'change'
          }]
        },
        6: {
          operation: [{
            required: true,
            message: this.$t('请选择') + this.$t('操作'),
            trigger: 'change'
          }]
        },
        7: {}
      };
    }
  },
  methods: {
    init(arr) {
      this.isEdit = false;
      this.controlList = recursionCopy(arr);
      this.dialogVisible = true;
    },
    controlItemFun(val) {
      this.isEdit = true;
      if (val.statistical && val.statistical == 'amount') {
        // let obj = {
        //   controlName: val.name,
        //   partsType: val.type,
        //   other: 1,
        //   formName: '',
        //   controlExplain: '',
        //   promptText: '',
        //   type: '',
        //   statistical: val.statistical
        // };
        // const index = this.controlList.findIndex(fruit => fruit.controlTitle === '' && fruit.controlType === 'control');
        // if (index == -1) {
        //   this.controlList.push({controlTitle: '', controlType: 'control', control: [obj]});
        // } else {
        //   this.controlList[index].control.push(obj);
        // }
        // return;
        this.dataForm.statistical = val.statistical;
        this.dataForm.controlName = val.name;
        // this.checked = true;
      }
      this.controlType = 'control';
      this.controlTitle = val.name;
      this.dataForm.partsType = val.type;
      this.dataRules = this.controlInfo[val.infoId];
      this.plainOptions = fileFormat[val.type] || [];
      console.log(val, this.dataRules, this.dataForm);
    },
    controlGroupFun(val) {
      this.isEdit = val.icon ? true : false;
      this.controlType = val.type;
      this.controlTitle = val.name;
      if (!val.icon) {
        this.controlList.push(controlGroupInfo[val.category]);
      } else {
        this.dataGroupRules = this.controlInfo[val.infoId];
        this.dataGroupForm = controlGroupInfo[val.category];
      }
    },
    otherChangeFun(e) {
      this.checked = e.target.checked;
      if (this.controlType == 'control') {
        this.dataForm.other = e.target.checked ? 1 : 0;
      } else {
        this.dataGroupForm.other = e.target.checked ? 1 : 0;
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let obj = recursionCopy(this.dataForm);
          if (this.dataForm.partsType == 'picture' || this.dataForm.partsType == 'enclosure') {
            let arr = [];
            this.dataForm.template.map(item => {
              if (item.url) {
                arr.push(item.url);
              }
            });
            obj.template = arr;
          }
          const index = this.controlList.findIndex(fruit => fruit.controlTitle === this.name && fruit.controlType === 'control');
          if (index == -1) {
            this.controlList.push({
              controlTitle: this.name,
              controlType: this.controlType,
              control: [obj]
            });
          } else {
            this.controlList[index].control.push(obj);
          }
          this.resetForm();
          console.log(obj, 222221);
          // let =this.checkedType(this.name)
        }
      });
    },
    onGroupSubmit() {
      this.$refs.ruleGroupForm.validate(valid => {
        if (valid) {
          const obj = recursionCopy(this.dataGroupForm);
          if (obj.controlType == 'table' && obj.operation != 'addEditDel') {
            obj.controlTitle = '定损明细';
            obj.control.push({
              slots: {
                title: '定损意见'
              },
              dataIndex: 'loss',
              key: '7',
              align: 'center'
            });
          }
          if (obj.controlType == 'table' && obj.operation == 'nuclearDamage') {
            obj.controlTitle = '核损明细';
            obj.control.push({
              slots: {
                title: '核损意见'
              },
              dataIndex: 'damage',
              key: '8',
              align: 'center'
            });
          }
          this.controlList.push(obj);
          this.resetForm();
        }
      });
    },
    resetForm() {
      this.isEdit = false;
      this.checked = false;
      this.indeterminate = false;
      this.checkAll = false;
      // this.dataGroupForm = {};
      if (this.controlType == 'control') {
        this.dataForm = {
          partsType: '',
          formName: '',
          controlName: '',
          controlExplain: '',
          promptText: '',
          other: '',
          type: '',
          optionList: [],
          fileFormat: [],
          template: []
        };
      } else {
        this.dataGroupForm = {};
      }

      // console.log(this.dataForm);
    },
    textareaList() {
      this.dataForm.optionList = [];
      if (this.dataForm.option.indexOf(';') > -1) {
        this.dataForm.optionList = this.dataForm.option.split(';');
      } else {
        this.dataForm.optionList = [this.dataForm.option];
      }
    },
    // 文件格式状态改变
    onCheckAllChange(e) {
      Object.assign(this.dataForm, {
        fileFormat: e.target.checked ? this.plainOptions : []
      });
      this.indeterminate = false;
      this.checkAll = e.target.checked;
      this.toChangeUploadAccept(this.dataForm.fileFormat);
    },
    onChangeFormat(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length;
      this.checkAll = checkedList.length === this.plainOptions.length;
      this.$refs.ruleForm.validateField('fileFormat');
      this.toChangeUploadAccept(this.dataForm.fileFormat);
    },
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      console.log(data);
      if (data.length) {
        data = data.map(i => '.' + i);
        this.uploadAccept = data.join(',');
      } else {
        this.uploadAccept = 'image/*';
      }
    },
    clickPlus() {
      if (this.dataForm.fileFormat.length == 0) {
        this.fileDialog = false;
        this.$refs.ruleForm.validateField('fileFormat');
      } else {
        this.fileDialog = true;
      }
    },
    removeUploadFile(file) {
      const index = this.dataForm.template.indexOf(file);
      const newFileList = this.dataForm.template.slice();
      newFileList.splice(index, 1);
      this.dataForm.template = newFileList;
    },
    async handlePreview(file) {
      this.isShow = '';
      if (isImage(file.name)) {
        this.isShow = 'image';
      }
      if (isVideo(file.name)) {
        this.isShow = 'video';
      }
      this.isPDFShow = isPDF(file.name);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.isShow === 'image' || this.isShow === 'video') {
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.dataForm.template.indexOf(file);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible = true;
    },
    changeUpload({
      file,
      fileList
    }) {
      const isThanMax = file.size / 1024 / 1024 < 50;
      const isVideoThanMax = file.size / 1024 / 1024 < 300;
      if (isVideo(file.name)) {
        if (!isVideoThanMax) {
          this.$message.error(this.$t('文件最大不超300M'));
          return;
        }
      } else {
        if (!isThanMax) {
          this.$message.error(this.$t('文件最大不超50M'));
          return;
        }
      }
      const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1);
      const res = this.dataForm.fileFormat.indexOf(fileType);
      if (res > -1) {
        this.dataForm.template = fileList.map(item => {
          if (item.response && item.response.code == 200 && item.status == 'done') {
            if (process.env.NODE_ENV === 'production') {
              item.url = cryptoDecrypt(item.response.data).fileTempUrl;
            } else {
              item.url = item.response.data.fileTempUrl;
            }
          }
          return item;
        });
      } else {
        this.$message.error(this.$t('文件格式错误'));
      }
      setTimeout(() => {
        const classActions = document.getElementsByClassName('ant-upload-list-item-actions');
        if (classActions.length > 0) {
          for (const key in classActions) {
            if (classActions[key].firstChild) {
              classActions[key].firstChild.style.opacity = '1';
              classActions[key].firstChild.style.pointerEvents = 'initial';
            }
          }
        }
      }, 50);
    },
    handleControlDel(index) {
      let _this = this;
      this.$alert(_this.$t('是否确认删除该信息') + '?', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        _this.controlList.splice(index, 1);
      }).catch(() => {});
    },
    handleSure() {
      // if (this.controlList.length == 0) {
      //   return this.$message.error('请编辑再保存!');
      // }
      this.$emit('controlOk', this.controlList);
      this.$emit('cancel');
    }
  }
};